import { useNavigate } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Box,
  SelectChangeEvent,
  TextField,
  Button,
  Checkbox,
  Tooltip,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  MenuItem,
  Switch,
  Select,
} from "@mui/material";
import { useState } from "react";
import SearchBar from "../../components/SearchBar";
import React from "react";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import StarIcon from "@mui/icons-material/Star";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CloseIcon from "@mui/icons-material/Close";
import SwitchToggle from "../../components/SwitchToggle";

const ManageProducts = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedProducts, setSelectedProducts] = useState<string[]>([]);
  const [variantBreakdown, setVariantBreakdown] = useState<any>(null);

  const toggleSelectProduct = (id: string) => {
    setSelectedProducts((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  const products = [
    {
      id: "#PROD-001",
      name: "Men Sports Shoes",
      category: "Footwear",
      brand: "Nike",
      stock: 120,
      variants: [
        { id: "v1", name: "Red / 42", stock: 20 },
        { id: "v2", name: "Blue / 42", stock: 30 },
        { id: "v3", name: "Black / 42", stock: 70 },
      ],
      status: "Active",
      trending: { isTrending: true, type: "Auto" },
      vendorHealth: "Good",
      createdDate: "30 July 2025",
      image: "/static/images/placeholder.png",
      vendor: {
        name: "Mike Johnson",
        email: "mike@example.com",
        phone: "+1122334455",
      },
      rating: 4.5,
      reviewCount: 120,
      aiSummary: "Customers love the comfort and durability.",
      metrics: { velocity: 15, views: 1200, conversion: 4.2 },
      price: 150
    },
    {
      id: "#PROD-002",
      name: "Women Running Shoes",
      category: "Footwear",
      brand: "Adidas",
      stock: 45,
      variants: [],
      status: "Active",
      trending: { isTrending: false, type: "Manual" },
      vendorHealth: "Good",
      createdDate: "18 July 2025",
      image: "/static/images/placeholder.png",
      vendor: {
        name: "John Doe",
        email: "john@example.com",
        phone: "+123456789",
      },
      rating: 4.8,
      reviewCount: 45,
      aiSummary: "Highly recommended for running. Great fit.",
      metrics: { velocity: 8, views: 900, conversion: 3.5 },
      price: 250
    },
    {
      id: "#PROD-003",
      name: "Casual Sneakers",
      category: "Footwear",
      brand: "Puma",
      stock: 8,
      variants: [
        { id: "v4", name: "White / 40", stock: 4 },
        { id: "v5", name: "Grey / 40", stock: 4 },
      ],
      status: "Paused",
      trending: { isTrending: false, type: "Manual" },
      vendorHealth: "At Risk",
      createdDate: "05 July 2025",
      image: "/static/images/placeholder.png",
      vendor: {
        name: "Jane Smith",
        email: "jane@example.com",
        phone: "+987654321",
      },
      rating: 3.9,
      reviewCount: 8,
      aiSummary: "Good for casual wear, but durability issues reported.",
      metrics: { velocity: 2, views: 400, conversion: 1.2 },
      price: 180
    },
    {
      id: "#PROD-004",
      name: "Men Cotton T-Shirt",
      category: "Clothing",
      brand: "H&M",
      stock: 200,
      variants: [],
      status: "Pending Review",
      trending: { isTrending: true, type: "Manual" },
      vendorHealth: "Good",
      createdDate: "22 June 2025",
      image: "/static/images/placeholder.png",
      vendor: {
        name: "Sarah Lee",
        email: "sarah@example.com",
        phone: "+9988776655",
      },
      rating: 4.2,
      reviewCount: 200,
      aiSummary: "Soft fabric, very comfortable. True to size.",
      metrics: { velocity: 25, views: 3000, conversion: 5.1 },
      price: 65
    },
    {
      id: "#PROD-005",
      name: "Women Hoodie",
      category: "Clothing",
      brand: "Zara",
      stock: 12,
      variants: [],
      status: "Draft",
      trending: { isTrending: false, type: "Manual" },
      vendorHealth: "Suspended",
      createdDate: "12 June 2025",
      image: "/static/images/placeholder.png",
      vendor: {
        name: "John Doe",
        email: "john@example.com",
        phone: "+123456789",
      },
      rating: 4.6,
      reviewCount: 12,
      aiSummary: "Warm and stylish. Perfect for winter.",
      metrics: { velocity: 1, views: 150, conversion: 0.8 },
      price: 120
    },
    {
      id: "#PROD-006",
      name: "Leather Wallet",
      category: "Accessories",
      brand: "Fossil",
      stock: 90,
      variants: [],
      status: "Archived",
      trending: { isTrending: false, type: "Manual" },
      vendorHealth: "Good",
      createdDate: "02 June 2025",
      vendor: {
        name: "Jane Smith",
        email: "jane@example.com",
        phone: "+987654321",
      },
      rating: 4.7,
      reviewCount: 90,
      aiSummary: "Premium quality leather. Great gift item.",
      image: "/static/images/placeholder.png",
      metrics: { velocity: 4, views: 600, conversion: 2.1 },
      price: 85
    },
    {
      id: "#PROD-007",
      name: "Smart Watch Series 8",
      category: "Accessories",
      brand: "Apple",
      stock: 5,
      variants: [],
      status: "Active",
      trending: { isTrending: true, type: "Auto" },
      vendorHealth: "Good",
      createdDate: "28 May 2025",
      image: "/static/images/placeholder.png",
      vendor: {
        name: "Mike Johnson",
        email: "mike@example.com",
        phone: "+1122334455",
      },
      rating: 4.9,
      reviewCount: 5,
      aiSummary: "Excellent features and battery life.",
      metrics: { velocity: 12, views: 2500, conversion: 6.5 },
      price: 1200
    },
    {
      id: "#PROD-008",
      name: "Wireless Earbuds",
      category: "Accessories",
      brand: "Samsung",
      stock: 60,
      variants: [],
      status: "Active",
      trending: { isTrending: false, type: "Manual" },
      vendorHealth: "At Risk",
      createdDate: "15 May 2025",
      image: "/static/images/placeholder.png",
      vendor: {
        name: "Sarah Lee",
        email: "sarah@example.com",
        phone: "+9988776655",
      },
      rating: 4.3,
      reviewCount: 60,
      aiSummary: "Good sound quality, but connectivity can be spotty.",
      metrics: { velocity: 6, views: 800, conversion: 2.8 },
      price: 350
    },
  ];

  const filteredProducts = products.filter((product) =>
    product.name.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const toggleSelectAll = (checked: boolean) => {
    if (checked) {
      setSelectedProducts(filteredProducts.map((p) => p.id));
    } else {
      setSelectedProducts([]);
    }
  };

  const totalInventoryValue = products.reduce((acc, p) => acc + (p.stock * p.price), 0);
  const lowMovingItems = products.filter(p => p.metrics.velocity < 5);
  const lowMovingPercent = products.length > 0 ? ((lowMovingItems.length / products.length) * 100).toFixed(0) : "0";
  const topProductsByValue = [...products].sort((a, b) => (b.stock * b.price) - (a.stock * a.price)).slice(0, 5);

  return (
    <>
      <div className="main_title ">
        <h1>Manage Products</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          Manage Products
        </p>
      </div>

      {/* Stats Boxes with AI Insights */}
      <div className="stats_boxes gap_m">
        <a className="cards">
          <div className="data_top">
            <h2>
              {products.length}
              <p>Total Products</p>
            </h2>
            <figure className="blue">
              <Inventory2OutlinedIcon fontSize="large" />
            </figure>
          </div>
        </a>

        <a className="cards">
          <div className="data_top">
            <h2>
              {products.filter(p => p.status === 'Active').length}
              <p>Active</p>
            </h2>
            <figure className="blue">
              <CheckCircleIcon fontSize="large" />
            </figure>
          </div>
        </a>

        <a className="cards">
          <div className="data_top">
            <h2>
              {products.filter(p => p.stock <= 10).length}
              <p>Low Stock</p>
            </h2>
            <figure className="warning">
              <ReportProblemOutlinedIcon fontSize="large" />
            </figure>
          </div>
        </a>

        <a className="cards">
          <div className="data_top">
            <h2>
              AED {totalInventoryValue.toLocaleString()}
              <p>Inventory Value</p>
            </h2>
            <figure className="warning">
              <AccountBalanceWalletOutlinedIcon fontSize="large" />
            </figure>
          </div>
        </a>

        {/* AI Insight 1 */}
        <div className="cards insight_card" style={{ background: '#f0f9ff', border: '1px solid #bae6fd' }}>
          <div className="data_top">
            <h2 style={{ fontSize: '14px' }}>
              Top 5 Valued Products
              <Box component="ul" sx={{ mt: 1, p: 0, listStyle: 'none', fontSize: '11px', color: '#0369a1' }}>
                {topProductsByValue.map(p => (
                  <li key={p.id}>• {p.name}: AED {(p.stock * p.price).toLocaleString()}</li>
                ))}
              </Box>
            </h2>
            <figure className="blue" style={{ background: '#e0f2fe' }}>
              <AssessmentOutlinedIcon sx={{ color: '#0ea5e9' }} />
            </figure>
          </div>
        </div>

        {/* AI Insight 2 */}
        <div className="cards insight_card" style={{ background: '#fff7ed', border: '1px solid #ffedd5' }}>
          <div className="data_top">
            <h2 style={{ fontSize: '14px' }}>
              {lowMovingPercent}% Value in Low-Moving Items
              <p style={{ fontSize: '11px', marginTop: '4px' }}>{lowMovingItems.length} items with low velocity</p>
            </h2>
            <figure className="warning" style={{ background: '#ffedd5' }}>
              <ErrorOutlineIcon sx={{ color: '#f97316' }} />
            </figure>
          </div>
        </div>
      </div>

      <div className="cards mt_20">
        {/* Bulk Action Bar */}
        {selectedProducts.length > 0 && (
          <div className="bulk_action_bar" style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            padding: '12px 20px',
            background: '#fff',
            borderRadius: '8px',
            marginBottom: '16px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
            border: '1px solid #e5e7eb',
            position: 'sticky',
            top: '10px',
            zIndex: 100
          }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 700, mr: 2 }}>
              {selectedProducts.length} Products Selected
            </Typography>
            <Button variant="outlined" size="small" sx={{ textTransform: 'none' }}>Mark Trending</Button>
            <Button variant="outlined" size="small" sx={{ textTransform: 'none' }}>Export Selected</Button>
            <Box component="a" onClick={() => setSelectedProducts([])} sx={{ cursor: 'pointer', color: '#3b82f6', ml: 'auto', fontSize: '14px' }}>Cancel</Box>
          </div>
        )}

        <div className="table_header">
          <div className="left_s ">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search products..."
            />
            <div className="form">
              <select>
                <option value="all">All Categories</option>
                <option value="footwear">Footwear</option>
                <option value="clothing">Clothing</option>
                <option value="accessories">Accessories</option>
              </select>

              <select>
                <option value="all">All Brands</option>
                <option value="nike">Nike</option>
                <option value="adidas">Adidas</option>
                <option value="puma">Puma</option>
              </select>

              <select>
                <option value="all">All Status</option>
                <option value="active">Active</option>
                <option value="draft">Draft</option>
                <option value="archived">Archived</option>
              </select>
            </div>
          </div>
          <div className="right_s">
            <Button className="btn btn_primary" onClick={() => navigate("/add-product")}>Add New Product</Button>
          </div>
        </div>

        <TableContainer className="table_container" sx={{ mt: 3 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell padding="checkbox">
                  <Checkbox
                    indeterminate={selectedProducts.length > 0 && selectedProducts.length < filteredProducts.length}
                    checked={filteredProducts.length > 0 && selectedProducts.length === filteredProducts.length}
                    onChange={(e) => toggleSelectAll(e.target.checked)}
                  />
                </TableCell>
                <TableCell>ID</TableCell>
                <TableCell>Vendor Details</TableCell>
                <TableCell>Product Detail</TableCell>
                <TableCell>Category</TableCell>
                <TableCell>Brand</TableCell>
                <TableCell>Reviews & AI</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Trending</TableCell>
                <TableCell>Stock</TableCell>
                <TableCell>Created Date</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredProducts.map((item, index) => (
                <TableRow key={index} hover selected={selectedProducts.includes(item.id)}>
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={selectedProducts.includes(item.id)}
                      onChange={() => toggleSelectProduct(item.id)}
                    />
                  </TableCell>
                  <TableCell>{item.id}</TableCell>
                  <TableCell>
                    <Box
                      component="a"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/manage-users/detail", {
                          state: { user: item.vendor },
                        });
                      }}
                      className="user_block click_action"
                    >
                      <Box display="flex" alignItems="center" gap={1}>
                        <div style={{
                          width: '8px',
                          height: '8px',
                          borderRadius: '50%',
                          background: item.vendorHealth === 'Good' ? '#22c55e' : item.vendorHealth === 'At Risk' ? '#f59e0b' : '#ef4444'
                        }} title={`Health: ${item.vendorHealth}`} />
                        <p>
                          <b>{item.vendor.name}</b>
                          <span>
                            {item.vendor.email}{" "}
                            <img
                              src="/static/images/tick_icon.svg"
                              alt="verified"
                            />
                          </span>
                        </p>
                      </Box>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box display="flex" alignItems="center" gap={2}>
                      <img
                        src={item.image}
                        alt={item.name}
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "6px",
                          objectFit: "cover",
                          background: "#f5f5f5",
                        }}
                      />
                      <Box>
                        <p style={{ fontWeight: 600 }}>{item.name}</p>
                        <Typography variant="caption" sx={{ color: 'gray' }}>AED {item.price}</Typography>
                      </Box>
                    </Box>
                  </TableCell>
                  <TableCell>{item.category}</TableCell>
                  <TableCell>{item.brand}</TableCell>
                  <TableCell>
                    <Box>
                      <Box display="flex" alignItems="center" gap={0.5}>
                        <StarIcon sx={{ color: "#faaf00", fontSize: 18 }} />
                        <span style={{ fontWeight: 600 }}>{item.rating}</span>
                        <span style={{ color: "gray", fontSize: "0.85rem" }}>
                          ({item.reviewCount})
                        </span>
                      </Box>
                      <Typography variant="caption" sx={{ color: '#666', fontStyle: 'italic', display: 'block', lineHeight: 1.2 }}>
                        {item.aiSummary}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                   <SwitchToggle/>
                  </TableCell>
                  <TableCell>
                    <Box display="flex" alignItems="center" gap={1}>
                      {item.trending.isTrending ? (
                        <Tooltip title={`Trending (${item.trending.type})`}>
                          <TrendingUpIcon sx={{ color: '#22c55e' }} />
                        </Tooltip>
                      ) : (
                        <TrendingDownIcon sx={{ color: '#9ca3af' }} />
                      )}
                      <IconButton size="small">
                        <StarIcon sx={{ color: item.trending.isTrending ? '#faaf00' : '#e5e7eb' }} />
                      </IconButton>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box
                      sx={{ cursor: item.variants.length > 0 ? 'pointer' : 'default' }}
                      onClick={() => item.variants.length > 0 && setVariantBreakdown(item)}
                    >
                      <span className={`stock_value ${item.stock <= 10 ? "low" : "normal"}`}>
                        {item.stock}
                      </span>
                      {item.variants.length > 0 && (
                        <Typography variant="caption" sx={{ display: 'block', color: '#3b82f6' }}>
                          ({item.variants.length} variants)
                        </Typography>
                      )}
                    </Box>
                  </TableCell>

                  <TableCell>{item.createdDate}</TableCell>
                  <TableCell className="form">

                    <Select
                      size="small"
                      defaultValue="Pending"

                    >
                      <MenuItem value="Pending">Pending</MenuItem>
                      <MenuItem value="Approve">Approve</MenuItem>
                      <MenuItem value="Reject">Reject</MenuItem>
                    </Select>
                    <IconButton onClick={() => navigate("/manage-products/view")}>
                      <img src="/static/images/eye_icon.svg" alt="View" />
                    </IconButton>

                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      {/* Variant Breakdown Dialog */}
      <Dialog open={Boolean(variantBreakdown)} onClose={() => setVariantBreakdown(null)} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ m: 0, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6">Variant Breakdown - {variantBreakdown?.name}</Typography>
          <IconButton onClick={() => setVariantBreakdown(null)} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Variant</TableCell>
                <TableCell align="right">Stock</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {variantBreakdown?.variants.map((v: any) => (
                <TableRow key={v.id}>
                  <TableCell>{v.name}</TableCell>
                  <TableCell align="right">{v.stock}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ManageProducts;
